export const GET_MAINTENANCE_REQUEST = `@@ddw.herdnet.sandbox.hnadvice/GET_MAINTENANCE_REQUEST`;
export const GET_MAINTENANCE_SUCCESS = `@@ddw.herdnet.sandbox.hnadvice/GET_MAINTENANCE_SUCCESS`;
export const GET_MAINTENANCE_FAILURE = `@@ddw.herdnet.sandbox.hnadvice/GET_MAINTENANCE_FAILURE`;
